import { render } from "./Evaluation1.vue?vue&type=template&id=d1d06242"
import script from "./Evaluation1.vue?vue&type=script&lang=js"
export * from "./Evaluation1.vue?vue&type=script&lang=js"
script.render = render

export default script